import {
	DocIdtoUploadType,
	PrvSellLookUp,
	PrvSellLookUpStateKeys,
	PSDocument,
	PSellRequestStatusId,
	RemoteDocument,
	SellRequestListing,
	uploadDocResponse
} from "./enitites";
import { loadLookUp, uploadDoc } from "./api";
import { CurrencyUtil, LocaleUtil, StringUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";

function PSLookUpToStateKey( lookup: PrvSellLookUp ): string {
	if ( PrvSellLookUpStateKeys[ lookup ] ) {
		return PrvSellLookUpStateKeys[ lookup ];

	}
	return lookup as string;
}

export function populatePrvtSellLookup( lookup: PrvSellLookUp, stateHolder?: any, callback?: ( values?: any ) => void ) {
	loadLookUp( lookup ).then( ( lkpData: any ) => {
		const stateKey = PSLookUpToStateKey( lookup );
		if ( stateHolder ) {
			stateHolder.setState( {
				[ stateKey ]: lkpData,
			} );
		}
		if ( callback ) {
			callback( lkpData );
		}
	} ).catch( ( reason: any ) => {
			if ( callback ) {
				callback( undefined );
			}
		},
	);
}


export function uploadDocs( docs: PSDocument[] ): Promise<any> {
	const uploadTasks: Promise<any>[] = [];
	for ( let doc of docs ) {
		if ( doc.remoteDoc ) {
			uploadTasks.push( Promise.resolve( doc.remoteDoc ) );
		} else {
			let extData = doc.localData?.split( ";" )[ 0 ];
			let type = extData?.includes( "image" ) ? "jpg" : "pdf";
			let encoded = doc.localData?.replace( /^data:(.*;base64,)?/, "" )!;
			if ( ( encoded.length % 4 ) > 0 ) {
				encoded += "=".repeat( 4 - ( encoded.length % 4 ) );
			}
			let docType = DocIdtoUploadType( doc.identity! );
			uploadTasks.push( uploadDoc( encoded, docType, type ).then( ( response: uploadDocResponse ) => {
				return checkUploadDocErrors( response ).then( ( resp: uploadDocResponse ) => {
					return Promise.resolve( getDocument( resp, doc ) );
				} ).catch( ( reason: any ) => {
					return Promise.reject( reason.toString() );
				} );
			} ).catch( ( reason: any ) => {
				return Promise.reject( reason.toString() );
			} ) );
		}
	}
	return Promise.all( uploadTasks );
}

function checkUploadDocErrors( response: any ): Promise<any> {
	if ( response.hasOwnProperty( "exceptionMessage" ) ) {
		if ( response.exceptionMessage && !StringUtil.isEmptyStringOrNull( response.exceptionMessage ) ) {
			let message = response.exceptionMessage;
			return Promise.reject( message );
		}
	}
	return Promise.resolve( response );
}

function getDocument( resp: uploadDocResponse, doc: PSDocument ): RemoteDocument {
	return {
		documentType: doc.documentType,
		documentTypeId: doc.identity,
		url: resp.fileShortPath,
		id: doc.remoteDoc ? doc.remoteDoc.id : 0,
	} as RemoteDocument;
}

function getDocumentsOld( docs: uploadDocResponse[] ): RemoteDocument[] {
	const documentDetails: RemoteDocument[] = [];
	docs.forEach( ( doc: uploadDocResponse ) => {
		const detail: RemoteDocument = {
			documentType: {
				identity: 4,
				nameAr: "PropertyImages",
				nameEn: "PropertyImages",
				parentId: 0,
			},
			documentTypeId: 4,
			url: doc.fileShortPath,
			id: 0,
		};
		documentDetails.push( detail );
	} );
	return documentDetails;
}

export function getPSRquestId( item: SellRequestListing ) {
	return item.id.toString();
}

export function getPropertyInfo( item: SellRequestListing ) {
	const property = ( getProperty( item ) as any );
	return property ? LocaleUtil.getLocalValue( property.title ) : "";
}

export function getAskingPrice( item: SellRequestListing ) {
	return CurrencyUtil.convertValueToCurrency( item.sellDetail!.askingPrice ) + " " + Strings.aed;
}

export function getStatus( tr: SellRequestListing ) {
	return LocaleUtil.getLocalValue( tr.status );
}

export function getTransactionDuration( tr: SellRequestListing ) {
	return LocaleUtil.getLocalValue( tr.sellDetail!.transactionDuration );
}

export function getStatusClass( tr: SellRequestListing ) {
	switch ( tr.status?.identity ) {
		case PSellRequestStatusId.Booked:
			return "pending";
		case PSellRequestStatusId.Submit_To_Audit:
			return "under-auditing";
		case PSellRequestStatusId.Approved:
			return "rera-approval";
		case PSellRequestStatusId.Completed:
			return "completed";
		case PSellRequestStatusId.Booking_Expired:
			return "cancel";
		case PSellRequestStatusId.Buyer_Reject:
			return "rejected";
		case PSellRequestStatusId.Audit_Rejected:
			return "rejected";
	}
}

function getProperty( tr: SellRequestListing ): AssetCard | undefined {
	let property: AssetCard | undefined = undefined;
	if ( tr.propertyInfo !== undefined ) {
		if ( tr.propertyInfo.propertyObject ) {
			try {
				property = JSON.parse( tr.propertyInfo.propertyObject! );
			} catch ( error ) {

			}
		}
	}
	return property;
}

export function normalizeRemoteDocToPSDocument( remoteDoc: RemoteDocument[] ): PSDocument[] {
	const documentDetails: PSDocument[] = [];
	remoteDoc.forEach( ( doc: RemoteDocument ) => {
		const detail: PSDocument = {
			remoteDoc: doc,
		};
		documentDetails.push( detail );
	} );
	return documentDetails;
}
